module.exports = __webpack_public_path__ + "static/media/2013.0b3c98e8.jpg";